module.exports = __webpack_public_path__ + "dingbeauty-landing/img/icon_cloud.b6526620.svg";